module.exports = __webpack_public_path__ + "img/__icon_MEGA.0d390922.svg";